import { css } from "@emotion/react";

export const formStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const sectionsRowStyle = css`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  align-content: flex-start;
  padding-bottom: 26px;
`;

export const sectionCard = css`
  height: 100%;

  .ant-card-head-title {
    font-weight: bold;
  }
`;

export const actionsStyle = css`
  flex-shrink: 0;
  margin-bottom: 0;
  padding-top: 16px;
  border-top: 1px solid #e3e3e4;
`;
